import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const axios = require("axios").default;

function EditFC() {
  let params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [OGTitle, setOGTitle] = useState("");
  const [OGDescription, setOGDescription] = useState("");

  useEffect(() => {
    setTitle(state.title);
    setDescription(state.description);

    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/${params.setname}`,
        {
          token,
        }
      )
      .then(function (response) {
        console.log(response.data[0]);
        const data = response.data[0];
        let foundCard = data.flashcards.find((obj) => {
          return obj.id === +params.id;
        });

        setOGTitle(foundCard.title);
        setOGDescription(foundCard.description);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  function EditCard(e) {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (title === OGTitle && description === OGDescription) {
      setError("Cant be same as before");
    } else {
      if (title.length === 0 || description.length === 0) {
        setError("Fields can't be empty");
      } else {
        axios
          .post(
            `https://application-flashcards.herokuapp.com/api/flashcards/edit/${state.id}`,
            {
              token,
              title,
              description,
            }
          )
          .then(function (response) {
            console.log(response);
            axios
              .post(
                `https://application-flashcards.herokuapp.com/api/sets/edit/${params.setname}`,
                {
                  token,
                  setName: params.setname,
                  highScore: 0,
                  mostRecentScore: 0,
                }
              )
              .then(function (response) {
                console.log(response);
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(function (error) {
            console.log(error);
          });

        window.location.href = `https://aquamarine-gingersnap-e8df1d.netlify.app/dashboard/set/${params.setname}`;
      }
    }
  }

  return (
    <>
      <form className="rounded-lg border-solid border border-slate-300 my-2 w-4/12 shadow-xl p-5 mx-auto mt-16 xsm:mx-auto xsm:my-5 xsm:w-10/12 md:w-6/12">
        <h2 className="font-semibold text-2xl my-3">Edit Card</h2>
        <label for="set_title">Title:</label>
        <input
          className="w-full border border-slate-300 w-full mt-1 mb-3"
          id="set_title"
          type="text"
          defaultValue={`${state.title}`}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />
        <label for="set_description">Description:</label>
        <textarea
          className="resize-none w-full border border-slate-300 w-full mt-1 mb-3"
          style={{ height: "10rem" }}
          id="set_description"
          defaultValue={`${state.description}`}
          onChange={(e) => {
            setDescription(e.target.value);
          }}
        />
        <div className="flex justify-end">
          <button
            className="w-2/12 text-white bg-red-400 border-solid border border-neutral-50 rounded p-1 hover:bg-red-500 lg:w-4/12"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            className="w-2/12 text-white bg-green-300 border-solid border border-neutral-50 rounded p-1 hover:bg-green-500 lg:w-4/12"
            type="submit"
            onClick={EditCard}
          >
            Edit
          </button>
        </div>
      </form>
      {error ? <p>{error}</p> : null}
    </>
  );
}

export default EditFC;
